<app-navbar
  [scrolled]="scrolled()"
  [isDark]="isDark()"
  [links]="navLinks"
  [portalUrl]="portalUrl"
  (toggleDark)="toggleDark()"
  (openMenu)="openMenu()"
/>

<main>
  <app-hero />

  @defer (on idle) {
    <app-beneficios />
  } @placeholder {
    <div style="min-height:600px"></div>
  }

  @defer (on idle) {
    <app-planes />
  } @placeholder {
    <div style="min-height:600px"></div>
  }

  @defer (on idle) {
    <app-cobertura />
  } @placeholder {
    <div style="min-height:600px"></div>
  }

  @defer (on idle) {
    <app-empresas />
  } @placeholder {
    <div style="min-height:600px"></div>
  }

  @defer (on idle) {
    <app-testimonios />
  } @placeholder {
    <div style="min-height:400px"></div>
  }

  @defer (on idle) {
    <app-faq />
  } @placeholder {
    <div style="min-height:400px"></div>
  }

  @defer (on idle) {
    <app-cta-final />
  } @placeholder {
    <div style="min-height:300px"></div>
  }
</main>

<app-footer />

<app-chatbot />

<!-- Mobile menu sheet -->
<div class="sheet" [class.open]="menuOpen()" (click)="closeMenu()">
  <div class="sheet__panel" (click)="$event.stopPropagation()">
    <div class="sheet__header">
      <strong>Menú</strong>
      <button class="cn-iconbtn cn-iconbtn--md cn-iconbtn--outline" aria-label="Cerrar" (click)="closeMenu()">
        <lucide-icon name="x" [size]="20" />
      </button>
    </div>
    @for (link of navLinks; track link.href) {
      <a class="sheet__link" [href]="link.href" (click)="closeMenu()">{{ link.label }}</a>
    }
    <div class="sheet__footer">
      <a class="cn-btn cn-btn--secondary cn-btn--md cn-btn--full" [href]="portalUrl" target="_blank" rel="noopener noreferrer">Acceder</a>
      <a class="cn-btn cn-btn--accent cn-btn--md cn-btn--full" href="#planes" (click)="closeMenu()">Contratar</a>
    </div>
  </div>
</div>
